export var keyCodes = {
  backspace: 8,
  tab: 9,
  enter: 13,
  esc: 27,
  pageUp: 33,
  pageDown: 34,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
}
